import {Request} from "@/Request";

class Table extends Request {

}

export default new Table();